import { useDispatch, useSelector, useStore } from 'react-redux';

import type { AppDispatch, AppStore, RootState } from './index';

/**
 * Pre-typed Redux hooks. Always use these — the untyped `useSelector` and
 * `useDispatch` from react-redux give you `any` state and an untyped dispatch,
 * which silently defeats every type guarantee in the store.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
